import styled from 'styled-components'

export type AssetIconProps = {
  // TODO: color type
  color: string
  isSelected: boolean
}

export const AssetIconWrapperStyled = styled.svg<AssetIconProps>`
  width: ${({ isSelected }) => (isSelected ? '60px' : '44px')};
  height: ${({ isSelected }) => (isSelected ? '60px' : '44px')};
  fill: none;
`

export const AssetIconBorderStyled = styled.circle<AssetIconProps>`
  fill: ${({ isSelected, color }) => (isSelected ? color : '#fff')};
  stroke: ${({ isSelected, color }) => (!isSelected ? color : '#fff')};
  stroke-width: 2;
`
